import "core-js/modules/es6.function.name";

/* eslint-disable react/no-array-index-key */
import React from 'react';
import DocTypeWrapper from './DocTypeWrapper';
import JsDocFunctionSignature, { isFunctionDef } from './JsDocFunctionSignature';
import TypeExpression from './JsDocTypeExpression';

var TypeComponent = function TypeComponent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: "token builtin"
  }, children);
};

export default function JsDocSignature(_ref2) {
  var definition = _ref2.definition,
      _ref2$ignoreParams = _ref2.ignoreParams,
      ignoreParams = _ref2$ignoreParams === void 0 ? [] : _ref2$ignoreParams,
      _ref2$fallbackToName = _ref2.fallbackToName,
      fallbackToName = _ref2$fallbackToName === void 0 ? false : _ref2$fallbackToName,
      _ref2$block = _ref2.block,
      block = _ref2$block === void 0 ? false : _ref2$block;

  if (isFunctionDef(definition, false)) {
    return /*#__PURE__*/React.createElement(JsDocFunctionSignature, {
      block: block,
      definition: definition,
      ignoreParams: ignoreParams
    });
  }

  if (definition.type && definition.type.typeDef) {
    return /*#__PURE__*/React.createElement(JsDocSignature, {
      definition: definition.type.typeDef,
      fallbackToName: true,
      block: block
    });
  }

  if (definition.type) {
    return /*#__PURE__*/React.createElement(DocTypeWrapper, {
      block: block
    }, /*#__PURE__*/React.createElement(TypeExpression, {
      type: definition.type
    }));
  }

  if (fallbackToName && definition.name) {
    return /*#__PURE__*/React.createElement(DocTypeWrapper, {
      block: block
    }, /*#__PURE__*/React.createElement(TypeComponent, null, definition.name));
  }

  return null;
}
export var fragment = "228399487";